import { Link } from 'react-router-dom';
import { ROUTES } from '../Routes';

const Footer = () => {
  const footerLinks = [
    { name: 'Terms', href: ROUTES.TERMS_AND_CONDITIONS },
    { name: 'Privacy', href: ROUTES.PRIVACY_POLICY },
    { name: 'About', href: ROUTES.ABOUT_US },
    { name: 'Contact', href: ROUTES.CONTACT_US },
  ];

  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>HOUSE REGISTRY</h4>
            <p>
              SF2 SIA<br />
              Kr. Valdemara iela 33-7<br />
              LV-1010 Riga, Latvia<br />
              Reg. no 40103691516
            </p>
          </div>

          <div className="footer-section">
            <h4>PASSAGES</h4>
            <div className="footer-links">
              {footerLinks.map(link => (
                <Link key={link.name} to={link.href}>{link.name}</Link>
              ))}
            </div>
          </div>

          <div className="footer-section">
            <h4>SIGNAL LANTERN</h4>
            <p>
              Email: <a href="/cdn-cgi/l/email-protection" className="__cf_email__"
                data-cfemail="1b72757d745b7f7a6970767a75687274757c7a767e6835787476">info@Talox.site</a><br />
              Website: https://Talox.site </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Talox Games. Social gaming entertainment — virtual Credits only. No real-money
            gambling and no cash rewards.</p>
          <p><strong>Notice:</strong> This is a <em>social gaming website</em>. All Credits are virtual. No
            deposits, withdrawals, or real-money payouts.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;